// Must load before any other app imports — sets up Buffer and process globals (Vite doesn't inject these unlike CRA/webpack).
import "./polyfills";
// Must run before any code that reads `navigator.connection` (e.g. @oneblink/apps).
import "./polyfills/navigatorConnection";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { Capacitor } from "@capacitor/core";
import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { REACT_APP_DOMAIN } from "./env";

// Call the element loader after the platform has been bootstrapped
defineCustomElements(window);

const domain = REACT_APP_DOMAIN || window.location.origin;

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App domain={domain ? domain : window.location.origin} />
  </React.StrictMode>,
);

// Service workers are not supported inside the native Capacitor WebView and are
// redundant there (the app shell is already bundled on-device). Only register on
// web; on native, unregister any previously installed worker.
if (Capacitor.isNativePlatform()) {
  serviceWorkerRegistration.unregister();
} else {
  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://cra.link/PWA
  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      if (registration && registration.waiting) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }
      window.location.reload();
    },
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
